export var HITWIT_BRAND_ASSET_VERSION = 'hitwit-symbol-2026-10-14';
var brandPaths = new Set([
    '/hitwit-logo-2026.light.png', '/hitwit-logo-2026.dark.png',
    '/hitwit_new.all.logoonly.png', '/hitwit_new.all.png', '/hitwit_new.light.png',
    '/hitwit_new.dark.png', '/hitwit_new.png', '/hitwit_logo_dark.png',
    '/hitwit.png', '/hitwit.jpg', '/hitwit.ico', '/favicon.ico', '/favicon.svg',
    '/static/hitwit.svg', '/static/assets/svg/hitwit_logo.svg',
    '/static/assets/svg/hitwit_logo_dark.svg', '/static/assets/svg/logofull.svg',
    '/static/assets/png/hitwit_logo_dark.png', '/static/assets/png/logo_white.png',
]);
// Replaced filenames need a fresh browser cache key, including URLs from domain config.
export var versionHitWitBrandAsset = function (value) {
    try {
        var url = new URL(value);
        var isHitWitHost = url.hostname === 'static.hitwit.ai'
            || /^hitwit-public\.s3(?:[.-][a-z0-9-]+)?\.amazonaws\.com$/.test(url.hostname);
        if (!isHitWitHost || !brandPaths.has(url.pathname))
            return value;
        url.searchParams.set('v', HITWIT_BRAND_ASSET_VERSION);
        return url.toString();
    }
    catch (_a) {
        return value;
    }
};
